export default __webpack_public_path__ + "assets/7ecd9a358cbee953f7b2edf51945a906.jpg";